// Which layout the New Enquiry form and the job page use (Mohammed 20/10: both go on TEST so MBP can choose).
// ONE_PAGE = design B (today's dialog, one page), TABS = design D (the dialog in tabs). The admin setting decides; the
// "For MBP review" menu opens either one with ?view= so both can be compared whatever the setting is.
import api from './sharedEnquiryApi'

export const ONE_PAGE = 'ONE_PAGE'
export const TABS = 'TABS'
export const LAYOUTS = [
  { value: ONE_PAGE, label: 'One page' },
  { value: TABS, label: 'Tabs' }
]

export function isLayout(v) {
  return v === ONE_PAGE || v === TABS
}

/** The layout a route asks for (?view=), or null to use the setting. */
export function viewOf(query) {
  const v = query && query.view
  return isLayout(v) ? v : null
}

/** "Comparing the New Enquiry form: tabs layout" while ?view= is set (the review menu's links), so the two links can be told apart. */
export function compareLabel(query) {
  const v = viewOf(query)
  if (!v) return null
  return 'Comparing the New Enquiry form: ' + (v === TABS ? 'tabs' : 'one page') + ' layout'
}

let cached = null

/** The setting, read once per page load; One page when it cannot be read (the endpoint is new). */
export function settingLayout() {
  if (!cached) {
    cached = api.formLayout()
      .then(r => (r && isLayout(r.layout) ? r.layout : ONE_PAGE))
      .catch(() => { cached = null; return ONE_PAGE })
  }
  return cached
}

/** After the admin saves a new layout, the next page reads it. */
export function forgetLayout() {
  cached = null
}

export async function resolveLayout(query) {
  return viewOf(query) || settingLayout()
}
